/** @jsxImportSource @emotion/react */
import React, { useEffect } from "react";
import SideNavigation from "../components/sideNavigation";
import Header2 from "../components/Header2";
import { layoutStyles } from "../assets/styles/layoutStyles"; // Style file for layout
import { AppDispatch, RootState } from "../store/store";
import useCustomStyles from "../hooks/useCustomStyles";
import { useDispatch, useSelector } from "react-redux";
import { selectBusinessTheme, selectState } from "../store/slices/themeSlice";
import { getDashboardTheme } from "../store/actions/businessActions";
import { setIsSideNavOpen } from "../store/slices/authSlice";

const Layout = ({ children }: { children: React.ReactNode }) => {
  const { activeTheme, mode, theme } = useSelector(selectState);
  const dispatch = useDispatch<AppDispatch>();
  // NEW: Business theme state - simple and clean
  const businessTheme = useSelector(selectBusinessTheme);
  
  // // Load theme on mount
  // useEffect(() => {
  //   if ( businessTheme && businessTheme.clientCode) {
  //     dispatch(getDashboardTheme({ clientCode: businessTheme.clientCode }));
  //   }
  // }, []);

  //useEffect(() => {
   //console.log('business theme', businessTheme); },[businessTheme]);

  // const dispatch = useDispatch<AppDispatch>();
  const classes = useCustomStyles(layoutStyles, theme);
  const { isSideNavOpen } = useSelector((state: RootState) => state.auth_slice);

  return (
    <div className={classes.container}>
      {/* Include the header */}
      <header className={classes.header}>
        <Header2 />
      </header>
      <div className={classes.subContainer}>
      {/* Include the side navigation */}
      <aside
        className={`${classes.sidebar} ${
          isSideNavOpen ? classes.sidebarOpen : ""
        }`}
      >
        <SideNavigation />
      </aside>

      {/* Mobile-only scrim behind the open sidebar; tapping it closes the sidebar */}
      {isSideNavOpen && (
        <div
          className={classes.backdrop}
          onClick={() => dispatch(setIsSideNavOpen())}
        />
      )}

      {/* Main content area */}
      <main
        className={`${classes.mainContent} ${
          isSideNavOpen ? classes.mainContentWithSidebar : ""
        }`}
      >
        {children}
      </main>
      </div>
    </div>
  );
};

export default Layout;
